import { Form } from 'react-bootstrap';
import { SwitchProps } from '../_models';
import CheckedIcon from '../../../assets/icon/logo-green.svg';
import UncheckedIcon from '../../../assets/icon/logo-red.svg';

const customSwitchStyles = `
.icon-switch .form-check-input::after {
  background-image: url(${UncheckedIcon});
}
.icon-switch .form-check-input:checked::after {
  background-image: url(${CheckedIcon});
}
`;

const IconSwitch: React.FC<SwitchProps> = ({ checked, onChange }) => (
  <>
    <style>{customSwitchStyles}</style>
    <Form.Check
      type="switch"
      checked={checked}
      onChange={onChange}
      className="icon-switch"
    />
  </>
);

export default IconSwitch;
